import Vue from "vue";
import axios from "axios";
import { msal, scopes } from "../main";

export default error => {
  const originalRequest = error.config;

  if (
    error.response &&
    error.response.status === 401 &&
    !originalRequest._isRetry &&
    Vue.$cookies.get("aad_b2c_session")
  ) {
    originalRequest._isRetry = true;

    if (msal.getAccount()) {
      return msal
        .acquireTokenSilent({ scopes })
        .catch(() => {
          msal.loginRedirect({ scopes });
        })
        .then(async res => {
          sessionStorage.setItem("access_token", res.accessToken);
          Vue.$cookies.set("aad_b2c_session", "active", "1h");
          originalRequest.headers.Authorization = `Bearer ${res.accessToken}`;
          return axios(originalRequest);
        });
    } else {
      msal.loginRedirect({ scopes });
    }
  }

  return Promise.reject(error);
};
